import { render, staticRenderFns } from "./DynamicSplash.vue?vue&type=template&id=54f2aa4e&"
import script from "./DynamicSplash.vue?vue&type=script&lang=js&"
export * from "./DynamicSplash.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports